import { Controller } from "@hotwired/stimulus"

// Handles checkbox interactions and communicates with filter-state controller
// Focuses solely on checkbox UI - state management handled by filter_state_controller
// Usage: data-controller="checkbox-filter"
export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.form = this.element.querySelector('form')
    
    // Find the filter state controller
    this.stateController = this.getStateController()
    
    // Listen for state changes from the filter state controller
    // Listen on the parent element where filter-state controller dispatches events
    this.boundStateChanged = this.stateChanged.bind(this)
    const stateElement = this.element.closest('[data-controller*="filter-state"]')
    if (stateElement) {
      stateElement.addEventListener('filter-state:state-changed', this.boundStateChanged)
      this.stateElement = stateElement
    }
  }

  disconnect() {
    if (this.stateElement) {
      this.stateElement.removeEventListener('filter-state:state-changed', this.boundStateChanged)
    }
  }

  // Get the filter state controller instance
  getStateController() {
    const stateElement = this.element.closest('[data-controller*="filter-state"]')
    return this.application.getControllerForElementAndIdentifier(stateElement, "filter-state")
  }

  // Auto-submit when filter checkboxes change
  autoSubmit(event) {
    // Small delay to allow checkbox state to update
    setTimeout(() => {
      const checkbox = event.target
      const filterType = checkbox.name.replace('[]', '')
      const values = this.getSelectedValues(filterType)
      
      // Tell state controller about the change
      if (this.stateController) {
        this.stateController.updateFilter(filterType, values)
      }
    }, 10)
  }

  // Get selected values for a specific filter type
  getSelectedValues(filterType) {
    return this.checkboxTargets
      .filter(cb => cb.name === `${filterType}[]` && cb.checked)
      .map(cb => cb.value)
  }

  // Get all filter field names from checkboxes
  getFilterNames() {
    return [...new Set(this.checkboxTargets.map(checkbox => checkbox.name.replace('[]', '')))]
  }

  // Handle state changes from filter state controller
  stateChanged(event) {
    const { state } = event.detail
    this.updateCheckboxes(state)
  }

  // Update checkbox states based on filter state
  updateCheckboxes(state) {
    // Clear all checkboxes first
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })

    // Set checkboxes based on state
    Object.entries(state).forEach(([filterType, values]) => {
      if (Array.isArray(values)) {
        this.checkboxTargets.forEach(checkbox => {
          if (checkbox.name === `${filterType}[]` && values.includes(checkbox.value)) {
            checkbox.checked = true
          }
        })
      }
    })
  }

  // Method to clear all filters (called by reset link)
  clearFilters(event) {
    event.preventDefault()
    
    if (this.stateController) {
      this.stateController.clearAllFilters()
    }
  }
}
